(() => {
  'use strict';
  if (window.woLensPromoLoaded) return;
  window.woLensPromoLoaded = true;
  const source = document.getElementById('wo-la-promo-text');
  const message = source ? source.content.textContent.trim() : '';
  if (!message) return;
  let scheduled = false;
  const mobile = window.matchMedia('(max-width: 1024px)');
  function sync() {
    scheduled = false;
    const modal = document.getElementById('lensadvizor-prescription-modal');
    if (!modal) return;
    const preview = modal.querySelector('.la-prescription-modal-image');
    const wrapper = modal.querySelector('.la-prescription-modal-wrapper');
    if (!preview || !wrapper) return;
    let banner = modal.querySelector('.wo-la-promo');
    if (!banner) {
      banner = document.createElement('div');
      banner.className = 'wo-la-promo';
      banner.textContent = message;
    }
    // The app moves its header on resize. Keep the mobile banner AFTER it.
    const header = wrapper.querySelector(':scope > .la-prescription-modal-header');
    const stacked = mobile.matches || getComputedStyle(wrapper).flexDirection === 'column';
    const previewHidden = getComputedStyle(preview).display === 'none';
    preview.classList.toggle('wo-la-promo-preview', !stacked && !previewHidden);
    if (stacked) {
      if (header) {
        if (header.nextElementSibling !== banner) header.after(banner);
      } else if (preview.previousElementSibling !== banner) {
        preview.before(banner);
      }
    } else if (previewHidden) {
      const body = modal.querySelector('.la-prescription-modal-content-body');
      if (body && body.firstElementChild !== banner) body.prepend(banner);
    } else if (preview.firstElementChild !== banner) {
      preview.prepend(banner);
    }
  }
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(sync);
  }
  const observer = new MutationObserver((records) => {
    if (records.some(record =>
      (record.target.nodeType === 1 && record.target.closest('#lensadvizor-prescription-modal')) ||
      Array.from(record.addedNodes).some(node => node.nodeType === 1 &&
        (node.id === 'lensadvizor-prescription-modal' || node.querySelector('#lensadvizor-prescription-modal')))
    )) schedule();
  });
  observer.observe(document.body, { childList: true, subtree: true });
  ['LensAdvizor:selectLensModal:open', 'LensAdvizor:lensOptions:rendered',
    'LensAdvizor:component:DidMount'].forEach(event => document.addEventListener(event, schedule));
  window.addEventListener('resize', schedule, { passive: true });
  schedule();
})();
